import type { DraftCartItem } from "@/domains/careplan/models/types";
import { SUBSCRIPTION_STATUS } from "@/domains/subscriptions/models/constants";
import type { SubscriptionStatus } from "@/domains/subscriptions/models/types";
import { icons } from "@/ui";
import { CartProduct } from "./cart-product";

type CartSubscribedProductProps = {
  product: DraftCartItem;
  status: SubscriptionStatus;
};

export const CartSubscribedProduct = ({ product, status }: CartSubscribedProductProps) => {
  return (
    <CartProduct.Root className="flex flex-col gap-4 border p-5 shadow-none" product={product}>
      <div className="flex gap-4">
        <CartProduct.Image className="size-20 rounded-lg sm:size-20" />
        <div className="flex flex-1 flex-col gap-1">
          <div className="flex justify-between gap-2">
            <CartProduct.Name level={3} />
            <p className="flex h-fit items-center gap-1 rounded-full bg-canvas px-3 py-1 text-sm font-medium text-content">
              <icons.CheckIcon className="size-3" />
              {status === SUBSCRIPTION_STATUS.PAUSED ? "Paused" : "Subscribed"}
            </p>
          </div>
          <CartProduct.Price className="text-base text-content sm:text-base" />
        </div>
      </div>

      <p className="text-sm">
        Quantity: <span className="font-semibold">{product.quantity}</span>
      </p>

      <div className="flex items-end justify-between">
        <CartProduct.ShippingFrequency />
        <p className="text-sm text-content-muted italic">Cancel anytime. No commitments.</p>
      </div>
    </CartProduct.Root>
  );
};
